import { lazy, type ComponentType } from "react";
const RELOAD_FLAG = "flogpt:chunk-reload-attempted";

function isChunkLoadError(error: unknown): boolean {
    if (!(error instanceof Error)) return false;
    const msg = error.message || "";
    return (
        /Failed to fetch dynamically imported module/i.test(msg) ||
        /Importing a module script failed/i.test(msg) ||
        /error loading dynamically imported module/i.test(msg) ||
        /Loading chunk \S+ failed/i.test(msg) ||
        /Loading CSS chunk \S+ failed/i.test(msg)
    );
}

export function lazyWithRetry<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
    return lazy(async () => {
        try {
            return await factory();
        } catch (error) {
            if (!isChunkLoadError(error)) throw error;

            let alreadyReloaded = false;
            try {
                alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === "1";
            } catch {

            }

            if (alreadyReloaded) throw error;

            try {
                sessionStorage.setItem(RELOAD_FLAG, "1");
            } catch {

            }

            window.location.reload();
            return new Promise<{ default: T }>(() => {});
        }
    });
}

export function clearChunkReloadFlag(): void {
    try {
        sessionStorage.removeItem(RELOAD_FLAG);
    } catch {
        // Storage unavailable — nothing to clear, nothing to do.
    }
}
